import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import styles from "../Analytics.module.css";

export const UserTable = ({ users }) => {

  
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;

  const totalPages = Math.ceil(users.length / rowsPerPage);
  const showPagination = users.length > rowsPerPage;

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = users.slice(indexOfFirstRow, indexOfLastRow);

  const handleDownload = () => {
    const worksheet = XLSX.utils.json_to_sheet(users);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    const file = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(file, 'user_info.xlsx');
  };

  // Pagination navigation handlers
  const goToNextPage = () => {
    setCurrentPage((page) => Math.min(page + 1, totalPages));
  };

  const goToPrevPage = () => {
    setCurrentPage((page) => Math.max(page - 1, 1));
  };

  const goToPage = (pageNum) => {
    setCurrentPage(pageNum);
  };

  // Calculate page numbers to show (max 3)
  let startPage = 1;
  let endPage = totalPages;

  if (totalPages > 3) {
    if (currentPage === 1) {
      startPage = 1;
      endPage = 3;
    } else if (currentPage === totalPages) {
      startPage = totalPages - 2;
      endPage = totalPages;
    } else {
      startPage = currentPage - 1;
      endPage = currentPage + 1;
    }
  } else {
    startPage = 1;
    endPage = totalPages;
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className={styles.tablecontainer}>
      <button
        onClick={handleDownload}
        style={{
          marginBottom: '10px',
          padding: '5px 10px',
          fontSize: '16px',
          fontWeight: '600',
          color: '#fff',
          backgroundColor: '#28a745',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#218838';
          e.currentTarget.style.boxShadow = '0 4px 8px rgba(33, 136, 56, 0.6)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#28a745';
          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
        }}
      >
        Download Excel
      </button>

      <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
        <thead>
          <tr style={{ backgroundColor: '#f4f4f4', color: 'black' }}>
            {Object.keys(users[0] || {}).map((key) => (
              <th key={key} style={{ border: '1px solid #ccc', padding: '10px', fontWeight: 'bold' }}>
                {key.toUpperCase()}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((row, index) => (
            <tr
              key={index}
              className={row.registration_type === 'New Registration' ? styles.newRow : styles.oldRow}
            >
              {Object.values(row).map((val, i) => (
                <td key={i} style={{ border: '1px solid #ddd', padding: '10px' }}>
                  {val}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {showPagination && (
        <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
          <button
            onClick={goToPrevPage}
            disabled={currentPage === 1}
            style={{
              padding: '5px 10px',
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              backgroundColor: currentPage === 1 ? '#ccc' : '#28a745',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
            }}
          >
            Prev
          </button>

          {pageNumbers.map((pageNum) => (
  <button
    key={pageNum}
    onClick={() => goToPage(pageNum)}
    style={{
      padding: '5px 10px',
      backgroundColor: currentPage === pageNum ? 'black' : '#28a745',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: currentPage === pageNum ? '700' : 'normal',
      boxShadow: currentPage === pageNum ? '0 0 5px 1px rgba(30, 126, 52, 0.7)' : 'none',
      transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
    }}
  >
    {pageNum}
  </button>
))}

          {(totalPages > 3) && (
            <button
              onClick={goToNextPage}
              disabled={currentPage === totalPages}
              style={{
                padding: '5px 10px',
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                backgroundColor: currentPage === totalPages ? '#ccc' : '#28a745',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
              }}
            >
              Next
            </button>
          )}
        </div>
      )}
    </div>
  );
};
